var map = {
	"./bg-1.jpeg": 3369,
	"./logo.jpg": 9218,
	"./svg-1.svg": 6117,
	"./svg-2.svg": 9675,
	"./svg-3.svg": 4878,
	"./svg-4.svg": 1008,
	"./user.png": 4353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;